import React, { useContext, useEffect, useRef } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import Swiper from "swiper/js/swiper.js";

import { setOverlayValue } from "store";
import ImageGalleryContext from "context/image-gallery-context";

import Container from "partials/Container";
import GridElement from "partials/GridElement";
import Image from "partials/Image";

import Arrow from "icons/ArrowIcon";
import Cross from "icons/CrossIcon";

import Media from "css/Media";

const ImageGallery = (props) => {
  const imageGalleryContext = useContext(ImageGalleryContext);
  const swiperRef = useRef(null);
  const { images, startAt } = props;

  useEffect(() => {
    initSwiper();
    window.addEventListener("touchmove", preventScroll, {
      passive: false,
    });
    return () => {
      window.removeEventListener("touchmove", preventScroll);
    };
  }, []);

  const clickHandler = () => {
    document.getElementsByTagName("html")[0].style.overflowY = "visible";
    props.setOverlayValue({ visible: false });
    imageGalleryContext.setOpen(false);
  };

  const preventScroll = (e) => {
    return e.preventDefault();
  };

  const initSwiper = () => {
    const swiper = new Swiper(swiperRef.current, {
      slidesPerView: 1,
      initialSlide: findStart(),
      allowTouchMove: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  };

  const findStart = () => {
    let magicNumber = 0;
    images.map((image) => {
      if (image.image.id === startAt.id) {
        magicNumber = images.indexOf(image);
      }
      return null;
    });
    return magicNumber;
  };

  return (
    <Wrapper>
      <Container grid rows='65px 1fr 65px'>
        <GridElement
          colStart={{ default: 7, s: 23 }}
          colEnd={{ default: 8, s: 24 }}
          rowStart={1}
          justify='end'
          align='end'
        >
          <BrexitButton onClick={clickHandler}>
            <Cross black />
          </BrexitButton>
        </GridElement>
        <SwiperGridElement
          colStart={{ default: 1, s: 3 }}
          colEnd={{ default: 8, s: 22 }}
          rowStart={2}
          align='center'
        >
          <div className='swiper-container' ref={swiperRef}>
            <div className='swiper-wrapper'>
              {images.map((image) => {
                return (
                  <div className='swiper-slide' key={image.image.id}>
                    <StyledImage image={image.image} loadInstantly />
                    <p>{image.image.caption}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </SwiperGridElement>
        {images.length > 1 && (
          <GridElement
            colStart={{ default: 1 }}
            colEnd={{ default: 2 }}
            rowStart={{ default: 1, s: 2 }}
            justify='start'
            align={{ default: "end", s: "center" }}
          >
            <div className='swiper-button-prev'>
              <Arrow />
            </div>
          </GridElement>
        )}
        {images.length > 1 && (
          <GridElement
            colStart={{ default: 3, s: 23 }}
            colEnd={{ default: 4, s: 24 }}
            rowStart={{ default: 1, s: 2 }}
            justify='end'
            align={{ default: "end", s: "center" }}
          >
            <div className='swiper-button-next'>
              <Arrow />
            </div>
          </GridElement>
        )}
      </Container>
    </Wrapper>
  );
};

const mapStateToProps = (state) => ({
  overlayValue: state.overlayValue,
});

const actions = {
  setOverlayValue,
};

export default connect(mapStateToProps, actions)(ImageGallery);

const Wrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: ${(props) => props.theme.colors.negative};

  .container {
    height: 100%;
  }

  .swiper-container {
    display: flex;
    height: 100%;
    width: 100%;
    overflow-x: hidden;
    .swiper-wrapper {
      display: flex;
      align-items: center;
      .swiper-slide {
        height: auto;
        p {
          text-align: center;
          padding-top: 20px;
        }
      }
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    ${Media.lessThan("s")`
      svg {
        display: flex;
        align-items: flex-end;
        height: 15.97px;
        width: 20.47px;
      }
  `}
  }

  .swiper-button-prev {
    transform: rotate(180deg);
  }
`;

const SwiperGridElement = styled(GridElement)`
  height: 100%;
  display: flex;
  align-items: center;
`;

const BrexitButton = styled.button`
  cursor: pointer;
`;

const StyledImage = styled(Image)`
  height: 100%;

  img {
    margin: auto;
    height: auto;
  }
`;
